import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import Table from "../../../ui/Table";
import Modal from "../../../ui/Modal";
import { GetHook, postEndpoint } from "../../../api/api";
import { ORGANISATION_URL, USER_URL } from "../../../api/urls";
import SearchInput from "../../../ui/SearchInput";
import { FieldArray, Formik } from "formik";
import { AttendeeCard } from "../../../components/AttendeeCard";
import { get } from "../../../utils/get";
import { AuthContext } from "../../../context/AuthContext";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { EditDeleteFormatter } from "../../../ui/TableFormatter";
import Axios from "../../../utils/axios";
import { DeleteIcon } from "../../../assets/svg/DeleteIcon";
import Swal from "sweetalert2";
const ReviewDepartmentsSettings = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const { data: organisations } = GetHook(ORGANISATION_URL);
  const [postRes, postReq] = postEndpoint();
  const [reviewOrganisations, setReviewOrganisations] = useState([]);
  const location = useLocation();
  const auth = useContext(AuthContext);

  const { user } = get(auth, "authState");
  const { data, error, pending, reload } = GetHook(
    `${USER_URL}/${get(user, "id")}/revieworganisation?owner_id=${get(
      user,
      "id"
    )}`
  );

  useEffect(() => {
    setReviewOrganisations(data);
  }, [data]);

  const closeModal = () => {
    setisModalOpen(false);

    // reload(get(location, "key"));
  };

  const handleAddReviewOrganisations = (values) => {
    const organisations = get(values, "organisations").map((org) => org.id);
    const payload = {
      organisations: organisations,
    };
    postReq(`${USER_URL}/${get(user, "id")}/revieworganisations`, payload);
  };
  useEffect(() => {
    const { complete, pending, data, error } = postRes;
    if (!pending && complete && data && !error) {
      toast.success("Organisations selected");
      closeModal();
      reload(get(location, "key"));
    }
  }, [postRes]);

  const handleDelete = (id) => {
    console.log(id);
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        Axios.delete(`${USER_URL}/${get(user, "id")}/revieworganisation/${id}`)
          .then((res) => {
            console.log(res);
            reload(get(location, "key"));
          })
          .catch((error) => toast.error(error.response.data.message));
      }
    });
  };
  const columns = [
    {
      Header: "Organization Name",
      accessor: "organisation.name",
    },
    // {
    //   Header: "Manager",
    //   accessor: "owner.names",
    // },
    // {
    //   Header: "Organisation Type",
    //   accessor: "organisation.organisation_type.name",
    // },
    // {
    //   Header: "Under",
    //   accessor: "organisation.parent_organisation.name",
    // },
    {
      id: "1",
      Header: "",
      Cell: ({ row }: any) => (
        <DeleteIcon
          onClick={() => handleDelete(row.original.organisation_id)}
        />
      ),
    },
  ];
  return (
    <Formik
      initialValues={{ organisations: reviewOrganisations }}
      onSubmit={(values) => handleAddReviewOrganisations(values)}
    >
      {({ values, handleSubmit }) => (
        <Container>
          <HeaderContainer>
            <TitleText>Review Departments</TitleText>
          </HeaderContainer>
          <Table
            data={reviewOrganisations}
            columns={columns}
            setModal={setisModalOpen}
          />
          {isModalOpen && (
            <Modal
              title="Select department"
              handleSubmit={handleSubmit}
              closeModal={closeModal}
            >
              <SearchInput />
              <FieldArray
                name="organisations"
                render={({ remove, push }) => (
                  <div>
                    {organisations.map((organisation, index) => (
                      <AttendeeCard
                        isPreSelected={
                          values.organisations.filter(
                            (attendee) => organisation === attendee
                          ).length > 0
                        }
                        key={index}
                        data={organisation}
                        setSelected={(isTrue) => {
                          return !isTrue
                            ? remove(organisation)
                            : push(organisation);
                        }}
                      />
                    ))}
                  </div>
                )}
              />
            </Modal>
          )}
        </Container>
      )}
    </Formik>
  );
};

export default ReviewDepartmentsSettings;

const Container = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #fff;
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;

const Status = styled.span`
  color: ${(props) => props.color};
  font-size: 12px;
`;
